import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Swatch = ({ value, onChange, testid }) => (
  <input type="color" value={value} onChange={(e) => onChange(e.target.value)} className="h-8 w-10 cursor-pointer rounded border bg-transparent" data-testid={testid} />
);

export default function DecorPanel({ decor, setDecor }) {
  const p = (x) => setDecor({ ...decor, ...x });
  return (
    <div className="border rounded-md p-3 space-y-3" data-testid="decor-panel">
      <p className="text-sm font-medium">Brand colour</p>
      <div className="flex items-end gap-3 flex-wrap">
        <label className="flex items-center gap-2 text-sm h-8"><Checkbox checked={decor.border} onCheckedChange={(v) => p({ border: !!v })} data-testid="decor-border-check" /> Border</label>
        <Swatch value={decor.border_color} onChange={(c) => p({ border_color: c })} testid="decor-border-color" />
        <div className="space-y-1"><Label className="text-xs">Thickness (pt)</Label>
          <Input type="number" step={0.25} min={0.25} max={12} value={decor.border_width} className="h-8 w-20"
            onChange={(e) => p({ border_width: Math.min(12, Math.max(0.25, parseFloat(e.target.value) || 0.25)) })} data-testid="decor-border-width" /></div>
      </div>
      <div className="flex items-end gap-3 flex-wrap">
        <div className="space-y-1"><Label className="text-xs">Stripe</Label>
          <Select value={decor.stripe} onValueChange={(v) => p({ stripe: v })}>
            <SelectTrigger className="h-8 w-28" data-testid="decor-stripe-select"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-card">
              {["none", "top", "bottom", "left", "right"].map((s) => <SelectItem key={s} value={s} data-testid={`stripe-opt-${s}`}>{s === "none" ? "No stripe" : s[0].toUpperCase() + s.slice(1)}</SelectItem>)}
            </SelectContent>
          </Select></div>
        <Swatch value={decor.stripe_color} onChange={(c) => p({ stripe_color: c })} testid="decor-stripe-color" />
        <div className="space-y-1"><Label className="text-xs">Stripe size (in)</Label>
          <Input type="number" step={0.01} min={0.02} max={2} value={decor.stripe_size} className="h-8 w-20"
            onChange={(e) => p({ stripe_size: Math.min(2, Math.max(0.02, parseFloat(e.target.value) || 0.02)) })} data-testid="decor-stripe-size" /></div>
      </div>
      <p className="text-xs text-muted-foreground">Colours print as long as "Background graphics" is on in the print dialog.</p>
    </div>
  );
}
